import { render, staticRenderFns } from "./LaporanOmzet.vue?vue&type=template&id=a27ce6e8&"
import script from "./LaporanOmzet.vue?vue&type=script&lang=js&"
export * from "./LaporanOmzet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports